import { render, staticRenderFns } from "./lpo_details.vue?vue&type=template&id=38d7baa8&"
import script from "./lpo_details.vue?vue&type=script&lang=js&"
export * from "./lpo_details.vue?vue&type=script&lang=js&"
import style0 from "./lpo_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports